export default "__VITE_ASSET__294a8474__"